import { Group } from '@wellesley/openapi'

export const isPrivateGroup = (group: Group | null) =>
  group?.privacy === 'PRIVATE'

export const isPublicGroup = (group: Group | null) =>
  group?.privacy === 'PUBLIC'

export const isSecretGroup = (group: Group | null) =>
  group?.privacy === 'PRIVATE' &&
  group?.visibility === 'HIDDEN' &&
  group?.joinMode === 'INVITE_ONLY'

export const isVisibleGroup = (group: Group | null) =>
  group?.visibility === 'VISIBLE'

export const isUnlistedGroup = (group: Group | null) =>
  group?.visibility === 'UNLISTED'

export const isHiddenGroup = (group: Group | null) =>
  group?.visibility === 'HIDDEN'

export const isInviteOnlyGroup = (group: Group | null) =>
  group?.joinMode === 'INVITE_ONLY'

export const isOpenGroup = (group: Group | null) => group?.joinMode === 'OPEN'

export const isRequestOnlyGroup = (group: Group | null) =>
  group?.joinMode === 'APPROVAL'
